(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setAnnouncementBarHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.createAnnouncementBarObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementBarHeight() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        if (announcementBar.classList.contains('announcement-bar-hidden')) {
          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        } else {
          document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBar.offsetHeight}px`);
        }
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.announcementBarObserver) {
        this.announcementBarObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    createAnnouncementBarObserver() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        this.announcementBarObserver = new MutationObserver(() => {
          this.setAnnouncementBarHeight();
        });

        this.announcementBarObserver.observe(announcementBar, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  function renderCaracteristicasFilters() {
  // Find the target container
  let newSubmenu = document.querySelector('.product-type-submenu');
  if (!newSubmenu) return;

  // Find the original caracterisiticas filter (try multiple selectors)
  let productTypeSubmenu = document.querySelector('.filter-type-caracterisiticas') || 
                          document.querySelector('[data-type="filter-type-caracterisiticas"]') ||
                          document.querySelector('#FacetFiltersFormMobile .js-filter[data-type="filter-type-caracterisiticas"]') ||
                          document.querySelector('#FacetFiltersForm .js-filter[data-type="filter-type-caracterisiticas"]');

  if (!productTypeSubmenu) {
    console.log('Caracterisiticas filter not found');
    return;
  }

  // Clear existing content
  newSubmenu.innerHTML = '';

  // Clone the filter content
  let duplicatedMenu = productTypeSubmenu.cloneNode(true);
  
  // Process cloned inputs to trigger original filters
  duplicatedMenu.querySelectorAll('input').forEach((input) => {
    const originalId = input.getAttribute('id');
    if (originalId) {
      input.setAttribute('data-original-id', originalId);
      input.setAttribute('id', originalId + '_duplicate');
    }
    
    // Remove name attribute since we're just triggering the original
    input.removeAttribute('name');
    
    // Fix any syntax issues in the value attribute
    const value = input.getAttribute('value');
    if (value && value.includes(',')) {
      input.setAttribute('value', value.replace(/,\s*$/, '').trim());
    }
    
    // Make input clickable and sync with original
    input.addEventListener('change', function (e) {
      // Add/remove checked class for styling
      if (input.checked) {
        input.classList.add('checked');
        input.closest('.mobile-facets__label')?.classList.add('checked');
      } else {
        input.classList.remove('checked');
        input.closest('.mobile-facets__label')?.classList.remove('checked');
      }
      
      // Find and sync the original filter in the main drawer
      const originalInput = document.querySelector(`#${originalId}`);
      if (originalInput) {
        // Sync the original input with the duplicated one
        originalInput.checked = input.checked;
        
        // Trigger the original filter's change event to activate filtering
        originalInput.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Also trigger input event for broader compatibility
        originalInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    
    // Add click handler to the label to ensure it works
    const label = input.closest('.mobile-facets__label') || input.closest('label');
    if (label) {
      // Remove any existing click handlers that might interfere
      label.onclick = null;
      
      label.addEventListener('click', function (e) {
        // Let the default behavior happen (toggles the input)
        // Then sync with original after a small delay
        setTimeout(() => {
          const originalInput = document.querySelector(`#${originalId}`);
          if (originalInput) {
            originalInput.checked = input.checked;
            originalInput.dispatchEvent(new Event('change', { bubbles: true }));
            originalInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }, 10);
      });
    }
    
    // Also sync when the original filter changes (to keep duplicates in sync)
    const originalInput = document.querySelector(`#${originalId}`);
    if (originalInput) {
      originalInput.addEventListener('change', function() {
        input.checked = originalInput.checked;
        
        // Update checked classes when syncing from original
        if (input.checked) {
          input.classList.add('checked');
          input.closest('.mobile-facets__label')?.classList.add('checked');
        } else {
          input.classList.remove('checked');
          input.closest('.mobile-facets__label')?.classList.remove('checked');
        }
      });
    }
    
    // Set initial checked state classes
    if (input.checked) {
      input.classList.add('checked');
      input.closest('.mobile-facets__label')?.classList.add('checked');
    }
  });

  // Add the duplicated menu to the container
  newSubmenu.appendChild(duplicatedMenu);
  
  console.log('Caracterisiticas filters rendered in submenu');
}

// Run the function when DOM is ready and after collection updates
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderCaracteristicasFilters);
} else {
  renderCaracteristicasFilters();
}

// Re-render after collection updates
document.addEventListener('collection:rendered', renderCaracteristicasFilters);
  
  


  } catch(e) { console.error(e); }
})();
})();
